export default "__VITE_ASSET__DQcooItA__"